<template>
  <TradeRowParentItem
    v-if="props.tradeItem.has_children"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :depth="$props.depth"
    :show-percentages="$props.showPercentages"
    :show-subcontract-summary="$props.showSubcontractSummary"
    :lump-sum-cost-ids-for-claim-period="$props.lumpSumCostIdsForClaimPeriod"
    :rates-cost-ids-for-claim-period="$props.ratesCostIdsForClaimPeriod"
  />

  <TradeRowItemWithClaim
    v-else-if="$props.claim.capture_claim_amount"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :depth="$props.depth"
    :show-percentages="$props.showPercentages"
    :show-subcontract-summary="$props.showSubcontractSummary"
    :lump-sum-cost-ids-for-claim-period="$props.lumpSumCostIdsForClaimPeriod"
    :rates-cost-ids-for-claim-period="$props.ratesCostIdsForClaimPeriod"
  />

  <TradeRowItemWithoutClaim
    v-else
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :depth="$props.depth"
    :show-percentages="$props.showPercentages"
    :show-subcontract-summary="$props.showSubcontractSummary"
    :lump-sum-cost-ids-for-claim-period="$props.lumpSumCostIdsForClaimPeriod"
    :rates-cost-ids-for-claim-period="$props.ratesCostIdsForClaimPeriod"
  />
</template>

<script setup lang="ts">
import Claim from '@/models/Claim';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import TradeRowItemWithClaim from './TradeRowItemWithClaim.vue';
import TradeRowItemWithoutClaim from './TradeRowItemWithoutClaim.vue';
import TradeRowParentItem from './TradeRowParentItem.vue';

const props = defineProps<{
  trade: Trade;
  claim: Claim;
  tradeItem: TradeItem;
  depth?: number;
  showPercentages?: boolean;
  showSubcontractSummary?: boolean;
  lumpSumCostIdsForClaimPeriod: Id[];
  ratesCostIdsForClaimPeriod: Id[];
}>();
</script>

<style scoped></style>
